import { render, staticRenderFns } from "./FoodData.vue?vue&type=template&id=1de91b6a"
import script from "./FoodData.vue?vue&type=script&lang=js"
export * from "./FoodData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports